export default __webpack_public_path__ + "static/shutdown-banner-mobile-97d7b32611a68c5a8466638ea76b38f1.png";